import { ResponseWrapper, ApiError } from './http';

import { BaseService } from './base.service';

export class AuthService extends BaseService {
  static get resourceEndpoint() {
    return 'auth';
  }

  static async login(data = {}) {
    try {
      const response = await this.request().post(
        `${this.resourceEndpoint}/login`,
        data
      );
      return new ResponseWrapper(response);
    } catch (error) {
      throw new ApiError(error);
    }
  }

  static async logout() {
    try {
      const response = await this.request().post(
        `${this.resourceEndpoint}/logout`
      );
      return new ResponseWrapper(response);
    } catch (error) {
      throw new ApiError(error);
    }
  }
}
